<template>
  <v-row class="dresscode-row">
    <div class="box">
      <div class="icon__background">
        <v-icon color="primary lighten-1" size="24">mdi-hanger</v-icon>
      </div>
      <div class="text">
        <span class="H6">{{ $t('pages.content.dresscode') }}</span>
        <span class="body-1">{{ dresscode }}</span>
      </div>
    </div>
  </v-row>
</template>
<script>
export default {
  props: {
    dresscode: {
      type: String,
      required: true,
    },
  },
}
</script>
<style scoped lang="scss">
.dresscode-row {
  padding: 0px 12px 5px;
  .box {
    display: flex;
    align-items: baseline;
    gap: 12px;
    .text {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>